module.exports = __webpack_public_path__ + "static/img/背景2.34dc13f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/WisdomSite/背景2.png
// module id = 7Q5C
// module chunks = 12